/* eslint-disable no-undef */
// __webpack_public_path__ is a webpack global variable

if (process.env.NODE_ENV === 'development') {
    __webpack_public_path__ = '/assets/packs/';
    console.log('[Public Path]', process.env.NODE_ENV, 'mode:', __webpack_public_path__);
} else if (process.env.NODE_ENV === 'test') {
    __webpack_public_path__ = '/packs-test/';
    console.log('[Public Path] test mode:', __webpack_public_path__);
} else if (process.env.NODE_ENV === 'staging') {
    const currentDomain = window.location.hostname;
    const stagingMatch = currentDomain.match(/^test(?<number>\d*)\.egbtest\.com$/u);

    if (stagingMatch) {
        const {groups: {number: testNumber}} = stagingMatch;
        const cdnBaseUrl = testNumber ? `https://assets${testNumber}.egbtest.com` : 'https://assets.egbtest.com';
        __webpack_public_path__ = `${cdnBaseUrl}/assets/packs/`;
        console.log('[Public Path] Staging mode:', __webpack_public_path__);
    } else {
        __webpack_public_path__ = '/assets/packs/';
        console.warn('[Public Path] Staging mode but domain not recognized:', currentDomain);
    }
} else {
    const PRODUCTION_CDN = 'https://assets.egbcdn.net';
    const CDN_BASE_META_NAME = 'egb-cdn-base';
    const cdnMeta = typeof document !== 'undefined' && document.querySelector(`meta[name="${CDN_BASE_META_NAME}"]`);
    const injectedCdn = cdnMeta && cdnMeta.getAttribute('content');
    const cdnBaseUrl = injectedCdn || PRODUCTION_CDN;

    __webpack_public_path__ = `${cdnBaseUrl}/assets/packs/`;
}
